module.exports = __webpack_public_path__ + "static/brainwire-76294ac4aa1b51891e6815ea645afe67.png";